// Czech

export default {

  component: {
    jobAdList: {
      title: 'Otevřené pracovní pozice',
      jobs: 'pracovní pozice',
      noJobAds: 'V současnosti nejsou žádné otevřené pracovní pozice.',
    },

    jobAdCard: {
      openUntil: date => `Otevřená do ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Děkujeme.',
      readyInfo: 'Vaši žádost jsme dostali a zanedlouho se vám ozve náborový pracovník.',
      luck: 'Hodně štěstí!',
    },

    jobAdSeeYou: {
      title: 'Děkujeme.',
      description: 'Vaše žádost o zaměstnání je uložená a odeslali jsme odkaz pro pokračování později.',
    },

    unpublished: {
      title: 'Nezveřejněno',
      info: 'Tento pracovní inzerát ještě není zveřejněný.',
    },
  },

  page: {},

}
